/** This export is automatically generated */
export const gitHash = '3c7cfcd76';
